import { AxiosResponse } from 'axios';

import { addFavoriteLeague, loadLeagues, removeFavoriteLeague } from '@/api/league';
import { LeagueItem } from '@/models/league';
import { baseListService } from '@/services/baseService';
import { ILeagueApiListResponse, ILeagueFilters } from '@/types';
import { IListParams } from '@/types/service';
import { AppError } from '@/errors/appError';
import { useLeagueStore } from '@/stores/league';
import { useAppStore } from '@/stores/app';

export const leagueService = {
    async load(params: IListParams<ILeagueFilters>): Promise<AxiosResponse<ILeagueApiListResponse>> {
        const leagueStore = useLeagueStore();
        const appStore = useAppStore();

        appStore.loading = true;
        try {
            const response = await baseListService<ILeagueApiListResponse>(loadLeagues, params);
            leagueStore.items = response.data.rows.map((item) => new LeagueItem(item));
            leagueStore.total = response.data.total;

            return response;
        } catch (e) {
            throw new AppError(`Unable load league list, request error`, { cause: e });
        } finally {
            appStore.loading = false;
        }
    },

    async addFavorite(clId: number): Promise<AxiosResponse | void> {
        const leagueStore = useLeagueStore();

        if (leagueStore.favoriteLeagueProcessing[clId]) {
            return;
        }

        leagueStore.favoriteLeagueProcessing[clId] = true;
        try {
            const response = await addFavoriteLeague(clId);
            leagueStore.favoriteLeague[clId] = 1;

            return response;
        } catch (e) {
            throw new AppError(`Unable to add favorite league #${clId}, request error`, { cause: e });
        } finally {
            delete leagueStore.favoriteLeagueProcessing[clId];
        }
    },

    async removeFavorite(clId: number): Promise<AxiosResponse | void> {
        const leagueStore = useLeagueStore();

        if (leagueStore.favoriteLeagueProcessing[clId]) {
            return;
        }

        leagueStore.favoriteLeagueProcessing[clId] = true;
        try {
            const response = await removeFavoriteLeague(clId);
            delete leagueStore.favoriteLeague[clId];

            return response;
        } catch (e) {
            throw new AppError(`Unable to delete favorite league #${clId}, request error`, { cause: e });
        } finally {
            delete leagueStore.favoriteLeagueProcessing[clId];
        }
    },
};
